var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 40,
    viewBox: "0 0 97 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=ELT"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line",
    x1: 20.5,
    y1: 19.5,
    x2: 32.5,
    y2: 19.5,
    stroke: "#AED2FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Src"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12,
    width: 24,
    height: 16,
    rx: 2,
    fill: "#AED2FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ChevronRightFilled",
    clipPath: "url(#clip0_24159_115525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.91 14L36.5 15.41L41.08 20L36.5 24.59L37.91 26L43.91 20L37.91 14Z",
    fill: "#265EDB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ChevronRightFilled_2",
    clipPath: "url(#clip1_24159_115525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M45.32 14L43.91 15.41L48.49 20L43.91 24.59L45.32 26L51.32 20L45.32 14Z",
    fill: "#265EDB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ChevronRightFilled_3",
    clipPath: "url(#clip2_24159_115525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M52.7299 14L51.3199 15.41L55.8999 20L51.3199 24.59L52.7299 26L58.7299 20L52.7299 14Z",
    fill: "#265EDB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Dest"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.73,
    y: 12,
    width: 24,
    height: 16,
    rx: 2,
    fill: "#AED2FF"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    x1: 64.5,
    y1: 19.5,
    x2: 76.5,
    y2: 19.5,
    stroke: "#AED2FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24159_115525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.41,
    height: 12,
    fill: "white",
    transform: "translate(36.5 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_24159_115525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.41,
    height: 12,
    fill: "white",
    transform: "translate(43.91 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_24159_115525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.41,
    height: 12,
    fill: "white",
    transform: "translate(51.3199 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElt);
export default __webpack_public_path__ + "static/media/elt.b43febe53b5ad2aa33351c74f854019d.svg";
export { ForwardRef as ReactComponent };